<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Cadastro Empresa Faturamentos" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="cadastrar()"
      />
    </div>

    <div class="flex flex-col">
      <div class="w-full flex">
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Inicial" />
          <b-datepicker
            v-model="form_pes.data_inicio"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('MM/YYYY')
            "  
          type="month"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
            @input="filtersItems"
          />
        </label>
        <label class="flex flex-col w-1/2 pb-6 pr-3">
          <Lynx-Label label="Data Final" />
          <b-datepicker
            v-model="form_pes.data_fim"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('MM/YYYY')
            "
              type="month"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
            @input="filtersItems"

          />
        </label>
      
        <!-- <label class="flex flex-col w-1/2 pb-6 pr-3">
           
          <Lynx-Button
            text="Relatorio Indicações"
            class="mb-4"
            style="margin-top:32px;"
            @click.native="gerarRelatorio()"
            size="small"
            icon-size="3"
          />
        </label> -->
      </div>
    </div>

    <b-table
      :columns="columns"
      :data="faturamento_filtro"
      :per-page="perPage"
      :paginated="true"
      default-sort-direction="desc"
      default-sort="mes"
      hoverables
      small
      class="w-full table-responsive  rounded-t-none"
    >
           
      <template v-if="props.row.empresa"  slot-scope="props">
        <b-table-column
          field="empresa"
          
        >
      {{ props.row.empresa.razao_social }}
      </b-table-column>
        <b-table-column field="cnpj" v-text="props.row.empresa.cnpj" />
        <b-table-column field="faturamento" v-text="props.row.faturamento" />
        <b-table-column field="mes" v-text="props.row.mes" />

        <!-- 
        <b-table-column field="acoes">
          <div class="flex text-sm">
            <div class="flex text-sm items-center">
           <a
                href="#"
                class="mr-4 bg-primary-600 rounded-full p-2"
                @click.prevent="atualizar(props.row)"
              >
                <Icon-Edit class="text-neutral-100" size="4" />
              </a>
              <a
                href="#"
                class="mr-4 bg-error-base rounded-full p-2"
                @click.prevent="confirm('delete',props.row)"
              >
                <Icon-Cross class="text-neutral-100" size="4" />
              </a> 
            </div>
          </div>
        </b-table-column> -->
      </template>
      <template #empty>
        <Not-Found-Data text="Nenhum tipo para a pesquisa informada" />
      </template>
    </b-table>

    <b-modal :active.sync="FaturamentoCadasModal" width="600px" id="modal-tall">
      <div class="bg-neutral-300 p-8">
        <div class="modal-body" style="height: 150px">
          <Lynx-Title text="Faturamentos" />
          <b-field class="file">
            <b-upload v-model="file" @input="handleOnInput">
              <a class="button is-primary">
                <span v-text="text" />
                <b-icon icon="upload" v-if="!loading" />
                <Lynx-Spinner
                  class="ml-2"
                  color="neutral-100"
                  size="4"
                  v-else
                />
              </a>
            </b-upload>
            <span class="rounded w-full bg-white" v-if="file">
              {{ file.name }}
            </span>
          </b-field>
        </div>

        <div class="flex flex-col mt-5">
          <Lynx-Button
            :disabled="loading"
            text="upload"
            class="mb-8"
            icon="Reload"
            @click.native="confirm('cria')"
            size="small"
            icon-size="3"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Card from "@/components/helpers/Card";
// import Template from "../../components/icons/Template.vue";
import moment from "moment";
import NotFoundData from "@/components/layouts/NotFoundData";
import { monthNames, dayNames } from '@/utils/utils'

export default {
  name: "index",
  data() {
    return {
      form_pes: {

      data_inicio: new Date(new Date()- 1 * 86400000) ,
        data_fim: new Date(),
      
      },
      monthNames,
      dayNames,
      moment,
      file: null,
      text: "",
      currentPage: 1,
      perPage: 10,
      loading: false,
      lista_campos: [],
      FaturamentoCadasModal: false,
      cliente: null,
      columns: [
        {
          field: "empresa.razao_social",
          label: "empresa",
          sortable: true,
          searchable: true,

        },
        {
          field: "empresa.cnpj",
          label: "cnpj",
          sortable: true,
          searchable: true,

        },
        {
          field: "faturamento",
          label: "faturamento",
          sortable: true,
          searchable: true,

        },
        {
          field: "mes",
          label: "mes",
          sortable: true,

        },
      ],
      faturamento_filtro:[]

    };
  },
  computed: {
    lista_faturamentos() {
      return this.$store.state.financeiro.lista_faturamentos;
    },
    mensagem_alert() {
      return this.$store.state.financeiro.mensagem_alert;
    },
  },
  created() {
    this.listar_faturamentos();
  },
  methods: {
    filtersItems(){

    this.faturamento_filtro  =      this.lista_faturamentos.filter(item => {
        const itemDate = moment(item.mes).format('MM/YYYY') 
          const startDate = moment(this.form_pes.data_inicio).format('MM/YYYY')  
          const endDate =  moment(this.form_pes.data_fim).format('MM/YYYY')
      
          // console.log(itemDate +' => '+ startDate+ ' = '+endDate)
       




          
          return itemDate >= startDate   && itemDate <= endDate  }

        ); 
    },
    async confirm(tipo) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um Tipo de Cobrança no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          // if (tipo == "edita") this.update();
          // if (tipo == "delete") this.delete(value);
        },
      });
    },
    async create() {
      const formData = new FormData();
      formData.append("file", this.file);
      this.loading = true;
      await this.$store
        .dispatch("financeiro/create_up_fatures", formData)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));

      this.FaturamentoCadasModal = false;
      this.listar_faturamentos();

      //   this.fireAlert({
      //     ...this.mensagem_alert,
      //     routeName: "produto",
      //   });
    },

    async listar_faturamentos() {
      await this.$store
        .dispatch("financeiro/listar_faturamentos")
        .finally(() => {
          // this.$store.dispatch("configEmpresa/atualizar", "");
          this.faturamento_filtro  = this.lista_faturamentos
        });
    },

    cadastrar() {
      this.FaturamentoCadasModal = true;
    },
  },
};
</script>

<style scoped>
</style>
